module.exports = __webpack_public_path__ + "static/media/wow.57095907.wav";